import React from "react";
import {
  FaMinus,
  FaPlus,
  FaTrash,
  FaArrowLeft,
  FaShoppingBag,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import API_BASE_URL from "../config/api";
import "./Cart.css";

function Cart() {
  const navigate = useNavigate();

  const {
    cartItems,
    cartTotal,
    updateQuantity,
    removeFromCart,
  } = useCart();

const imageUrl = (image) => {
  if (!image) return "";

  if (image.startsWith("http")) {
    return image;
  }

  return `${API_BASE_URL}/${image.replace(/^\/+/, "")}`;
};
  return (
    <main className="tv-cart-page">

      <div className="tv-cart-container">

        {/* HEADER */}

        <div className="tv-cart-header">

          <span>TIME VALLEY</span>

          <h1>Your Cart</h1>

          <p>
            Your selected timepieces, kept safely until
            you're ready to make them yours.
          </p>

        </div>

        {cartItems.length === 0 ? (

          /* EMPTY CART */

          <div className="tv-empty-cart">

            <FaShoppingBag />

            <h2>Your cart is empty</h2>

            <p>
              Discover our collection of refined timepieces.
            </p>

            <button
              onClick={() => navigate("/shop")}
            >
              CONTINUE SHOPPING
            </button>

          </div>

        ) : (

          <div className="tv-cart-layout">

            {/* PRODUCTS */}

            <div className="tv-cart-products">

              {cartItems.map((item) => (

                <div
                  className="tv-cart-item"
                  key={item.id}
                >

                  <div className="tv-cart-item-image">

                    <img
                      src={imageUrl(item.image1)}
                      alt={item.name}
                    />

                  </div>

                  <div className="tv-cart-item-info">

                    {item.tag && (
                      <span>
                        {item.tag}
                      </span>
                    )}

                    <h3>
                      {item.name}
                    </h3>

                    <strong>
                      Price{" "}
                      {Number(item.price).toFixed(2)}
                    </strong>

                    <div className="tv-cart-item-actions">

                      {/* QUANTITY */}

                      <div className="tv-cart-quantity">

                        <button
                          onClick={() =>
                            updateQuantity(
                              item.id,
                              item.quantity - 1
                            )
                          }
                        >
                          <FaMinus />
                        </button>

                        <span>
                          {item.quantity}
                        </span>

                        <button
                          onClick={() =>
                            updateQuantity(
                              item.id,
                              item.quantity + 1
                            )
                          }
                        >
                          <FaPlus />
                        </button>

                      </div>

                      {/* REMOVE */}

                      <button
                        className="tv-remove-cart"
                        onClick={() =>
                          removeFromCart(item.id)
                        }
                      >
                        <FaTrash />
                        Remove
                      </button>

                    </div>

                  </div>

                  {/* ITEM TOTAL */}

                  <div className="tv-cart-item-total">

                    Price{" "}
                    {(
                      Number(item.price) *
                      item.quantity
                    ).toFixed(2)}

                  </div>

                </div>

              ))}

            </div>

            {/* SUMMARY */}

            <aside className="tv-cart-summary">

              <span>
                ORDER SUMMARY
              </span>

              <h2>
                Your Order
              </h2>

              <div className="tv-summary-line">
                <span>Subtotal</span>

                <strong>
                  Price {cartTotal.toFixed(2)}
                </strong>
              </div>

              <div className="tv-summary-line">
                <span>Delivery</span>

                <strong>
                  Complimentary
                </strong>
              </div>

              <div className="tv-summary-divider"></div>

              <div className="tv-summary-total">
                <span>Total</span>

                <strong>
                  Price {cartTotal.toFixed(2)}
                </strong>
              </div>

            <button
  className="tv-checkout-button"
  onClick={() => navigate("/customer-details", {
    state: {
      cartItems,
    },
  })}
>
  PROCEED TO CHECKOUT
</button>

              <button
                className="tv-continue-shopping"
                onClick={() => navigate("/shop")}
              >
                <FaArrowLeft />
                Continue Shopping
              </button>

            </aside>

          </div>

        )}

      </div>

    </main>
  );
}

export default Cart;